import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { styledGetCustomComponentProperty } from '../../../../helpers';

interface InputDepictionProps {
  $show: boolean;
  $isSmall: boolean;
}

export const $InputDepiction = styled.div<InputDepictionProps>`
  color: ${({ theme }) => theme.colors.white};
  min-width: ${({ $show }) => ($show ? spacing(7) : 0)};
  width: ${({ $show }) => ($show ? spacing(7) : 0)};
  transition-duration: 0.25s;
  height: ${({ $isSmall }) => {
    if ($isSmall) {
      return '24px';
    }

    return styledGetCustomComponentProperty({
      componentName: SUPPORTED_COMPONENTS.DEFAULT_INPUTS,
      property: SUPPORTED_PROPERTIES.HEIGHT,
    });
  }};
  line-height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
export const $IcoContainer = styled.div`
  position: absolute;
  max-height: ${spacing('lg')};
`;
